import React, { ReactNode } from 'react';

interface CardsProps {
  border?: string;
  bg?: string;
  p?: string;
  children: ReactNode;
}

const Cards: React.FC<CardsProps> = ({
  border = '#E8E8E8',
  bg = '#ffffff',
  p = '20px',
  children
}) => {
  return (
    <section id="cards" className="h-full">
      <div
        className={`rounded-[14px] h-[inherit] ${p}`}
        style={{
          border: `1px solid ${border}`,
          backgroundColor: bg,
          padding: p
        }}
      >
        {children}
      </div>
    </section>
  );
};

export default Cards;
